import utils from '../utils';

/**
 * Convert a time signature to a formated HTML string
 * @param {string} timeSig in format "4/4"
 * @returns {string}
 */
export default function formatTimeSig(timeSig: string) {
  const parts = timeSig.toString().split('/');
  if (timeSig === 'C') {
    return `
      <span class="sr-only">C: Common time</span>
      <span aria-hidden="true" class="utheory-time-signature utheory-time-signature-c" style="font-family: Georgia, 'DejaVu Serif', serif;">
        <span style="display:inline-block; margin-bottom:-0.3em; vertical-align:-0.1em; line-height:0.85em; font-size:100%; text-align:center">
          <b>C</b>
        </span>
      </span>
    `;
  }

  if (timeSig === 'C|') {
    const id = utils.uuid;
    return `
      <span class="sr-only">C-slash: Cut time</span>
      <span aria-hidden="true" class="utheory-time-signature utheory-time-signature-c" style="font-family: Georgia, 'DejaVu Serif', serif;">
        <span id="time-signature-${id}" style="display:inline-block; margin-bottom:-0.3em; vertical-align:-0.1em; line-height:0.85em; font-size:100%; text-align:center">
          <b>C</b><span style="border-right-style: none; border-top-style: none; border-bottom-style: none; border-left-style: solid; border-width: 0.1em; border-color: currentColor; display: inline-block; height: 1em; transform: translate(-0.35em,0.15em);"></span>
        </span>
      </span>
    `;
  }

  // style from wikipedia time signature formatting
  return `
    <span class="sr-only">${parts[0]}/${parts[1]}</span>
    <span aria-hidden="true" class="utheory-time-signature utheory-time-signature-number" style="font-family: Arial Unicode MS, Lucida Sans Unicode;">
      <span style="font-family: Georgia, 'DejaVu Serif', serif;">
        <span style="display:inline-block;
          vertical-align:-0.21em;
          line-height:0.85em;
          font-size:80%;
          text-align:center">
          <b>${parts[0]}</b><br>
          <b>${parts[1]}</b>
        </span>
      </span>
    </span>
  `;
}
